var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-bold-alert',{staticClass:"inline-icon ml-2 text-red-500"})
}
var staticRenderFns = []

export { render, staticRenderFns }